// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-belmont -> weidner-apartment-homes-theme-belmont -> park-plaza
// Generated: 2026-10-29T23:13:49.116Z
// Counts: 0 design, 24 content, 16 slot group, 2 collection binding, 8 section, 0 style

export const designOverrides = {};

export const contentOverrides = {
  "audioeye-widget.cta_color": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_primary_color"
  },
  "audioeye-widget.cta_location": {
    "overrideType": "VALUE",
    "customValue": "left-lower",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.pretitle": {
    "overrideType": "VALUE",
    "customValue": "<p><span data-type=\"field-token\" data-field=\"property_bedrooms_range\"></span> Bedroom Layouts</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>Be a part of <span data-type=\"field-token\" data-field=\"property_address_city\"></span>'s most exciting luxury apartment community featuring brand new <span data-type=\"field-token\" data-field=\"property_bedrooms_range\"></span> bedroom floor plans.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Welcome to <span data-type=\"field-token\" data-field=\"property_name\"></span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodshowcase.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Settle into an Anchorage lifestyle with Park Plaza's unbeatable spot just south of downtown. Stroll to Chester Creek Sports Complex, catch a game at Ben Boeke Indoor Ice Arenas, or browse local finds at the Anchorage Farmers Market. Valley of the Moon Park is steps from your door for outdoor fun. Live at the center of city culture, delicious dining, and weekend markets, all just moments from home.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "pinnedcallouts.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>Tour Anytime, From Anywhere.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "pinnedcallouts.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Connect With Our Leasing Team in Anchorage</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.pre_title": {
    "overrideType": "VALUE",
    "customValue": "<p>A Home Design For You</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Discover Modern Comforts and City Convenience</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "facebook-pixel.pixel_ids": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_pixel_id"
  },
  "rentgrata-widget.property_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_rentgrata_token"
  },
  "scheduletourform.form.thank_you_url": {
    "overrideType": "VALUE",
    "customValue": "/thank-you",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Park Plaza in Anchorage, AK strikes the balance between cozy living and everyday ease. Step inside your home to find comforts like a dishwasher, separate dining room, large closets, and your own intercom or call box - with select homes offering private balconies or patios, walk-in closets, ceiling fans, and captivating views. Outside your door, community perks like on-site laundry facilities, bike storage, on-site management, and 24-hour emergency maintenance make daily life smoother. Smoke-free living and an easy online portal for payments and service requests round out a worry-free Anchorage rental experience.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Have a question about life at Park Plaza or want to make Anchorage your new home? Connect with our leasing team for more information and details about our apartments, floor plans, and the local community. We look forward to assisting you.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Looking for open layouts that make working from home or relaxing at the end of the day simple? At Park Plaza, our studio, one-, and two-bedroom apartments for rent in Anchorage, AK give you options for every lifestyle. Enjoy roomy living spaces, convenient dining areas, abundant storage with large closets, and in-home perks like a dishwasher and a personal intercom. Whether you want sunlight with your morning coffee or space to organize your things, you'll find the layout that works for you.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.title": {
    "overrideType": "VALUE",
    "customValue": "Find Your Perfect Apartment Layout at Park Plaza",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Picture yourself living comfortably at Park Plaza Apartments in Anchorage, AK. Explore photos that showcase bright kitchens, open dining spaces, and homes that feel inviting the moment you step inside. Take in community details, like the relaxing common areas and sense of belonging that comes from the neighborhood's community-oriented vibe. Scroll through and imagine every cozy moment you'll enjoy in your new home.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Enjoy life in Anchorage, AK with Park Plaza's location just south of downtown, putting parks, culture, and convenience at your doorstep. Walk or bike to Valley of the Moon Park for green spaces and trails, catch the action at Ben Boeke Indoor Ice Arena or Chester Creek Sports Complex, and pick up local produce at the Anchorage Farmers Market. Dining spots and everyday needs are minutes away, making it easy to grab a bite or meet up with friends nearby. Here, your Anchorage routine blends city energy with outdoor retreats.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodshowcase.pre_title": {
    "overrideType": "VALUE",
    "customValue": "<p>Park Plaza - Prime Anchorage Location</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodshowcase.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Connected living near top city spots</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Choose from stunning studio, one-, and two-bedroom apartments for rent in Anchorage, AK, at Park Plaza. Pet-friendly living is paired with coveted touches like big closets, a dining room, and a dishwasher that make relaxing at home easy. Park Plaza puts you close to Valley of the Moon Park, Ben Boeke Indoor Ice Arenas, and the Anchorage Farmers Market - so you can enjoy the best the city has to offer, close to home. Free on-site parking, 24-hour emergency maintenance, and on-site management provide day-to-day convenience, whether you're out adventuring or unwinding at home.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Ready for an inside look at Park Plaza Apartments in Anchorage, AK? We make touring easy. Use our virtual tour option for a flexible online walkthrough, or schedule a private in-person tour with our friendly leasing professionals. We make touring convenient for your schedule so you can picture life in your new space. Touring restrictions may apply.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Get a closer look at Park Plaza Apartments from anywhere you are. With the virtual tour, you can explore our layouts, experience the atmosphere, and picture daily living in Anchorage without stepping outside. Dive in and start imagining afternoons in your new home, the flow of the floor plan, and what Anchorage life would look like for you - all online and on your own time.</p>",
    "generatedValue": null,
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "contact-hero.cta_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "VALUE",
        "customValue": "View Floor Plans"
      }
    }
  },
  "pinnedcallouts.cta2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "VALUE",
        "customValue": "Schedule a Tour"
      }
    }
  },
  "propertyoverview.cta_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "VALUE",
        "customValue": "Choose Your New Home"
      }
    }
  },
  "contactform.form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/thank-you"
      }
    }
  },
  "footer.youtube": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "https://www.youtube.com/@WeidnerApartmentHomes"
      }
    }
  },
  "header.resident_access_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "FIELD_MAPPING",
        "mappedField": "property_resident_portal_url"
      }
    }
  },
  "floorplanslist.card_image_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167235/019d0226-7b84-718e-b034-1f6ea16d8f26.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Living room with sectional sofa, coffee table, and wall-mounted TV."
      }
    }
  },
  "floorplanslist.card_image_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167235/019d0226-86d3-72ed-b3c2-4eb4d7025ca2.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Living room, kitchen, and bathroom of an apartment"
      }
    }
  },
  "floorplanslist.card_image_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167235/019d0226-7945-76ae-bf02-fbaf5c782639.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Bedroom with a large window overlooking trees."
      }
    }
  },
  "floorplanslist.card_image_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167235/019d0226-86e6-72ce-8367-229118582dd4.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Empty living room with carpet, sliding glass door to balcony, and doorway to another room."
      }
    }
  },
  "floorplanslist.card_image_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167235/019d0226-9614-71e8-87f0-576d55a79969.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Interior view of a bedroom with a closet and a doorway to a bathroom."
      }
    }
  },
  "hero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "FIELD_MAPPING",
        "mappedField": "photo_gallery[7].image"
      }
    }
  },
  "neighborhoodshowcase.photo1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167235/019d0227-04d1-747f-9331-f88c136ed09b.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Groomed forest trails winding through Kincaid Park near Anchorage."
      }
    }
  },
  "neighborhoodshowcase.photo2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167235/019d0226-f569-760d-aced-1bbe806e189c.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "The Anchorage Museum, a downtown landmark of art and Alaskan culture."
      }
    }
  },
  "neighborhoodshowcase.photo3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167235/019d0227-21ce-763f-b671-9f8b8e02479c.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Tree-lined green space and playground at Valley of the Moon Park."
      }
    }
  },
  "neighborhoodshowcase.photo4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167235/019d0227-2544-7016-a080-8308da344ca9.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Open sports fields and recreation at Delaney Park in Anchorage."
      }
    }
  }
};

export const collectionBindingOverrides = {
  "galleryapartments.images": {
    "limit": null,
    "hiddenIds": null,
    "orderedIds": [
      "ec_5ead609448b179fc78e61425",
      "ec_e33c68f2a23c59428e000929",
      "ec_dac3dd1c24fa301f15bda6f8",
      "ec_4215f71e973eb32535761624",
      "ec_89e5a24dcba2746beda14cce",
      "ec_32dec0ad7ab36bae84317f98",
      "ec_cbf0dd4cad61788993405b1c",
      "ec_6ecaea891e9c6290b49efb9f",
      "ec_5db444a160e172e6b9d19657",
      "ec_c76b763176eeefa8606c7f8b",
      "ec_d7eb2bcace3c9183e4e65129",
      "ec_453e7a947f40e094d610e642",
      "ec_6fad13c17f18ada865a4b646",
      "ec_dc701cfe0601fb29429511b2"
    ],
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "propertyoverview.images": {
    "limit": null,
    "hiddenIds": [
      "ec_cbf0dd4cad61788993405b1c"
    ],
    "orderedIds": null,
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  }
};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "apartment-sync-loader",
      "blockId": "apartment-sync-loader",
      "position": 0
    },
    {
      "sectionId": "audioeye-widget",
      "blockId": "audioeye-widget",
      "position": 0
    },
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    },
    {
      "sectionId": "facebook-pixel",
      "blockId": "facebook-pixel",
      "position": 0
    },
    {
      "sectionId": "rentcafe-chatbot",
      "blockId": "rentcafe-chatbot",
      "position": 0
    },
    {
      "sectionId": "rentgrata-widget",
      "blockId": "rentgrata-widget",
      "position": 0
    }
  ]
};

export const styleOverrides = {};
